const DEFAULT_VIDEO_BASE_URL = '/api/videos';

/**
 * Base path of the video-access service that serves finished-game recordings
 * from the Hetzner Storage Box.
 *
 * In the cluster, admin-fe's nginx proxies /api/videos to the video-access pod,
 * so the default relative path is correct. For local development against a
 * remote environment, set REACT_APP_VIDEO_BASE_URL to an absolute URL.
 */
export const VIDEO_BASE_URL = process.env.REACT_APP_VIDEO_BASE_URL || DEFAULT_VIDEO_BASE_URL;
